module.exports = __webpack_public_path__ + "img/user.c8e5f5fc.png";